import { Fragment, ReactNode } from 'react';
import cn from 'classnames';
import { Logo } from '../../Logo/Logo';
import Footer from './Footer';
import './Layout.styles.css';

type Props = {
    children: ReactNode;
    headline?: ReactNode;
    description?: string;
    headerContent?: ReactNode;
    hideFooter?: boolean;
    footerContent?: ReactNode;
    mode?: 'error';
};

export const Layout = ({
    children,
    headline,
    description,
    headerContent,
    hideFooter = false,
    footerContent,
    mode,
}: Props) => {
    return (
        <Fragment>
            <div className="plLayout">
                <header className="navbar" data-test="header">
                    <Logo />
                    {headerContent && <div className="headerContent">{headerContent}</div>}
                </header>
                <main className={cn('main', mode)} data-test="main">
                    <div className="container">
                        {headline && (
                            <div className="headline" data-test="headline">
                                {headline}
                            </div>
                        )}
                        {description && (
                            <p className="description mb-10" data-test="description">
                                {description}
                            </p>
                        )}
                        {children}
                    </div>
                </main>
                {!hideFooter && <Footer>{footerContent}</Footer>}
            </div>
        </Fragment>
    );
};
